import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../src/environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const base = new URL(environment.apiUrl, window.location.origin);
  const url = new URL(req.url, window.location.origin);
  const prefix = base.pathname.replace(/\/$/, '');
  if (url.origin !== base.origin || !url.pathname.startsWith(`${prefix}/`)) return next(req);
  const path = url.pathname.slice(prefix.length);
  // Public platform registration must not inherit the currently signed-in tenant.
  if (path === '/token/login' || path.startsWith('/platform/')) {
    return next(req.clone({ headers: req.headers.delete('Authorization').delete('X-Tenant') }));
  }
  const token = localStorage.getItem('auth_token');
  const tenant = localStorage.getItem('tenant_domain');
  const setHeaders: Record<string, string> = {};
  if (token) setHeaders['Authorization'] = `Bearer ${token}`;
  if (tenant) setHeaders['X-Tenant'] = tenant;
  return next(Object.keys(setHeaders).length ? req.clone({ setHeaders }) : req);
};
